module.exports = {
	"name": "clever-tykes-portal",
	"version": "0.1.0",
	"private": true,
	"scripts": {
		"start": "concurrently -r \"npm run compile-scss\" \"react-scripts start\"",
		"build": "react-scripts build",
		"test": "react-scripts test --env=jsdom",
		"eject": "react-scripts eject",
		"compile-scss": "node-sass ./src/styles/style.scss -w -o ./src/styles",
		"clear": "npm rebuild node-sass"
	},
	"dependencies": {
		"alertify.js": "^1.0.12",
		"animate.css": "^3.5.2",
		"axios": "^0.15.2",
		"axios-mock-adapter": "^1.7.0",
		"classnames": "^2.2.5",
		"glamor": "^2.20.5",
		"immutable": "3.8.1",
		"key-mirror": "1.0.1",
		"localforage": "^1.4.3",
		"lockr": "^0.8.4",
		"moment": "^2.14.1",
		"normalizr": "^2.2.1",
		"pdfobject": "^2.0.201604172",
		"qs": "^6.2.1",
		"react": "^15.3.1",
		"react-dom": "^15.3.1",
		"react-dropzone": "^3.10.0",
		"react-ga": "^2.1.2",
		"react-helmet": "^3.1.0",
		"react-joyride": "^1.6.0",
		"react-redux": "4.4.6",
		"react-router": "^3.0.0",
		"redux": "3.6.0",
		"redux-actions": "^1.0.0",
		"redux-logger": "^2.6.1",
		"redux-persist": "4.0.0-alpha6",
		"redux-persist-transform-immutable": "^4.1.0",
		"redux-saga": "^0.13.0",
		"redux-thunk": "2.1.0",
		"reselect": "^2.5.4",
		"smooth-scroll": "github:cferdinandi/smooth-scroll",
		"underscore": "^1.8.3",
		"underscore.string": "^3.3.4"
	},
	"devDependencies": {
		"babel-eslint": "^7.0.0",
		"eslint": "^3.8.1",
		"eslint-config-airbnb": "^13.0.0",
		"eslint-plugin-flowtype": "^2.21.0",
		"eslint-plugin-import": "^2.0.1",
		"eslint-plugin-jsx-a11y": "^2.2.3",
		"eslint-plugin-react": "^6.4.1",
		"concurrently": "^3.1.0",
		"node-sass": "^3.9.0",
		"react-scripts": "0.8.1",
		"surge": "^0.18.0"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./package.json
 ** module id = 378
 ** module chunks = 0
 **/